import { BaseNetworkActionValidator } from '../base.network.action.validator';
import { TreeProtectedEntity } from '../../../helpers/types';
import { ProtectedEntitiesHelper } from '../../../helpers/protectedEntities/protected.entities.helper';

export abstract class CreateFolderAbstractValidator extends BaseNetworkActionValidator {
  protected canRunForUnmanagedCompanies = false;
  protected requiresTasksEnabled = false;
  protected canRunOnMultipleCompanies = false;

  // these are the types under which we can create folders. add the correct types for your use case in the child class
  protected abstract allowTypes: Array<number>;

  protected _canPerformAction(record: TreeProtectedEntity): boolean {
    if (!this.allowTypes.includes(record.type)) {
      return false;
    }

    // if they are readOnly (~not managed from above)
    if (record.readOnly) {
      return false;
    }

    // if the selected node requires manage companies right and the user doesn't have it
    if (
      ProtectedEntitiesHelper.isCompanyFolderOrCompanyCollection(record) &&
      !Application.Main.getUser().role.rights.manageCompanies
    ) {
      return false;
    }

    return true;
  }
}
